import apiService from 'src/enviroment'
import { loaderService } from 'src/services/loaderService'

const getPartners = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('gvc/socios/')
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getPartnersConfig = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('gvc/socios/configuracion/')
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getBosses = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('gvc/jefes/')
    if (response.status === 200) {
      return response.data
    }
  } catch (eror) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getRegions = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`admin/territorios/?unidad_negocio_id=${params}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (eror) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postQuiz = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('gvc/encuesta/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const postPartners = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('gvc/usuario/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const putPartners = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.put('gvc/usuario/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const updatePartner = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.put('gvc/jefes/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const createPartner = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.post('gvc/jefes/', params)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsCountry = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/pais/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsRegions = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/regiones/?desde=${params.since}&hasta=${params.until}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsManagers = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/gerentes/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsBosses = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/jefes/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsPartners = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/socio/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsQuizzes = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/encuesta/?desde=${params.since}&hasta=${params.until}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getIndicatorsActions = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`gvc/indicadores/acciones/?desde=${params.since}1&hasta=${params.until}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}
const getPartnersActions = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('gvc/acciones/')
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getGroupList = async () => {
  loaderService.show()
  try {
    const response = await apiService.get('/gvc/grupos/')
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getModulesCountry = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`/gvc/indicadores/pais_modulo_tipo/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200)
    return response.data
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getPartnerModuleType = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`/gvc/indicadores/socio_modulo_tipo/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getPartnerQuizzesScore = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`/gvc/indicadores/consolidado_grupo/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}

const getActionAreas = async (params) => {
  loaderService.show()
  try {
    const response = await apiService.get(`/gvc/indicadores/acciones_area_grupo/?desde=${params.since}&hasta=${params.until}&idGrupo=${params.idGrupo}`)
    if (response.status === 200) {
      return response.data
    }
  } catch (error) {
    return false
  } finally {
    loaderService.hide()
  }
}
export {
  getPartners,
  getPartnersConfig,
  getBosses,
  getRegions,
  postQuiz,
  postPartners,
  putPartners,
  updatePartner,
  createPartner,
  getIndicatorsCountry,
  getIndicatorsRegions,
  getIndicatorsManagers,
  getIndicatorsBosses,
  getIndicatorsPartners,
  getIndicatorsQuizzes,
  getIndicatorsActions,
  getPartnersActions,
  getGroupList,
  getModulesCountry,
  getPartnerModuleType,
  getPartnerQuizzesScore,
  getActionAreas
}
